<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Subcontract Good Receipt" active>

                                <b-row v-if="hasFailedDataSubcontractGoodReceipt">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSubcontractGoodReceipt.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceiptsFailed" :fields="fieldsSubcontractGoodReceipt" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceipt" :sort-desc.sync="sortDescSubcontractGoodReceipt" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSubcontractGoodReceipt.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceipts" :fields="fieldsSubcontractGoodReceipt" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceipt" :sort-desc.sync="sortDescSubcontractGoodReceipt" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Subcontract Good Receipt Detail" active>

                                <b-row v-if="hasFailedDataSubcontractGoodReceiptDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSubcontractGoodReceiptDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceiptDetailsFailed" :fields="fieldsSubcontractGoodReceiptDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceiptDetail" :sort-desc.sync="sortDescSubcontractGoodReceiptDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSubcontractGoodReceiptDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceiptDetails" :fields="fieldsSubcontractGoodReceiptDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceiptDetail" :sort-desc.sync="sortDescSubcontractGoodReceiptDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Subcontract Good Receipt Suggestion Detail" active>

                                <b-row v-if="hasFailedDataSubcontractGoodReceiptSuggestionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSubcontractGoodReceiptSuggestionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceiptSuggestionDetailsFailed" :fields="fieldsSubcontractGoodReceiptSuggestionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceiptSuggestionDetail" :sort-desc.sync="sortDescSubcontractGoodReceiptSuggestionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(usedQty)="row">
													{{ Number(row.item.usedQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSubcontractGoodReceiptSuggestionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractGoodReceiptSuggestionDetails" :fields="fieldsSubcontractGoodReceiptSuggestionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractGoodReceiptSuggestionDetail" :sort-desc.sync="sortDescSubcontractGoodReceiptSuggestionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(usedQty)="row">
													{{ Number(row.item.usedQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';
import SubcontractGoodReceiptList from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptList';
import SubcontractGoodReceiptFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsSubcontractGoodReceipt: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Subcontract Request Delivery Number", key: 'subcontractRequestDeliveryRequestDeliveryNumber', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},
				{"class" : "th-status", "label" : "Surat Jalan", key: 'suratJalan', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsSubcontractGoodReceiptDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Is Complete", key: 'isComplete', sortable: false},
				{"class" : "th-status", "label" : "Case Qty", key: 'caseQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsSubcontractGoodReceiptSuggestionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Case Qty", key: 'caseQty', sortable: false},
				{"class" : "th-status", "label" : "Used Qty", key: 'usedQty', sortable: false},
				{"class" : "th-status", "label" : "Is Scanned", key: 'isScanned', sortable: false},
				{"class" : "th-status", "label" : "Subcontract Good Receipt Detail", key: 'subcontractGoodReceiptDetailControlCard', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			subcontractGoodReceipts : [],
			subcontractGoodReceiptsFailed: [],
			subcontractGoodReceiptId : '',
			sortBySubcontractGoodReceipt: '',
			sortDescSubcontractGoodReceipt: '',
			hasFailedDataSubcontractGoodReceipt: false,
			totalFailedSubcontractGoodReceipt: 0,
			totalSucceedSubcontractGoodReceipt: 0,
			subcontractGoodReceiptDetails : [],
			subcontractGoodReceiptDetailsFailed: [],
			subcontractGoodReceiptDetailId : '',
			sortBySubcontractGoodReceiptDetail: '',
			sortDescSubcontractGoodReceiptDetail: '',
			hasFailedDataSubcontractGoodReceiptDetail: false,
			totalFailedSubcontractGoodReceiptDetail: 0,
			totalSucceedSubcontractGoodReceiptDetail: 0,

			subcontractGoodReceiptSuggestionDetails : [],
			subcontractGoodReceiptSuggestionDetailsFailed: [],
			subcontractGoodReceiptSuggestionDetailId : '',
			sortBySubcontractGoodReceiptSuggestionDetail: '',
			sortDescSubcontractGoodReceiptSuggestionDetail: '',
			hasFailedDataSubcontractGoodReceiptSuggestionDetail: false,
			totalFailedSubcontractGoodReceiptSuggestionDetail: 0,
			totalSucceedSubcontractGoodReceiptSuggestionDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('subcontractgoodreceipt/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('subcontractgoodreceipt/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getSubcontractGoodReceiptForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getSubcontractGoodReceiptForUpload : async function() {
			let _this = this;
			this.$http.get('subcontractgoodreceipt/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.subcontractGoodReceipts = [];
_this.subcontractGoodReceiptDetails = [];
_this.subcontractGoodReceiptSuggestionDetails = [];


					if (response != null) {
						let result = response.data;
						_this.subcontractGoodReceipts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedSubcontractGoodReceipt = _this.subcontractGoodReceipts.length;

						_this.subcontractGoodReceiptsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataSubcontractGoodReceipt = true;
						_this.totalFailedSubcontractGoodReceipt = 0;
						if(_this.subcontractGoodReceiptsFailed == undefined || _this.subcontractGoodReceiptsFailed.length === 0) _this.hasFailedDataSubcontractGoodReceipt = false;
						if(_this.hasFailedDataSubcontractGoodReceipt) _this.totalFailedSubcontractGoodReceipt = _this.subcontractGoodReceiptsFailed.length;
						_this.subcontractGoodReceiptDetails = [];
						_this.subcontractGoodReceiptDetailsFailed = [];
						_this.hasFailedDataSubcontractGoodReceiptDetail = true;
						_this.totalSucceedSubcontractGoodReceiptDetail = 0;
						result.forEach(function(element) {
							_this.subcontractGoodReceiptDetails.push(...element.subcontractGoodReceiptDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedSubcontractGoodReceiptDetail = _this.subcontractGoodReceiptDetails.length;

							_this.subcontractGoodReceiptDetailsFailed.push(...element.subcontractGoodReceiptDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.subcontractGoodReceiptDetailsFailed == undefined || _this.subcontractGoodReceiptDetailsFailed.length === 0) _this.hasFailedDataSubcontractGoodReceiptDetail = false;
							if(_this.hasFailedDataSubcontractGoodReceiptDetail) _this.totalFailedSubcontractGoodReceiptDetail = _this.subcontractGoodReceiptDetailsFailed.length;
						});						_this.subcontractGoodReceiptSuggestionDetails = [];
						_this.subcontractGoodReceiptSuggestionDetailsFailed = [];
						_this.hasFailedDataSubcontractGoodReceiptSuggestionDetail = true;
						_this.totalSucceedSubcontractGoodReceiptSuggestionDetail = 0;
						result.forEach(function(element) {
							_this.subcontractGoodReceiptSuggestionDetails.push(...element.subcontractGoodReceiptSuggestionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedSubcontractGoodReceiptSuggestionDetail = _this.subcontractGoodReceiptSuggestionDetails.length;

							_this.subcontractGoodReceiptSuggestionDetailsFailed.push(...element.subcontractGoodReceiptSuggestionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.subcontractGoodReceiptSuggestionDetailsFailed == undefined || _this.subcontractGoodReceiptSuggestionDetailsFailed.length === 0) _this.hasFailedDataSubcontractGoodReceiptSuggestionDetail = false;
							if(_this.hasFailedDataSubcontractGoodReceiptSuggestionDetail) _this.totalFailedSubcontractGoodReceiptSuggestionDetail = _this.subcontractGoodReceiptSuggestionDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'subcontractgoodreceipt/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'SubcontractGoodReceipt.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterSubcontractGoodReceipt = new SubcontractGoodReceiptFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
